import React from "react";
import FavoriteReportsComponent from '../modules/dashboard/components/favoriteReports';

export default function WelcomeView() {
    return (<div><h1>Welcome to EQ Insights Online</h1>
        <FavoriteReportsComponent />
    </div>);
}